import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';

import { useVideos } from 'models/vedio';

import { getIdFromYoutubeListLink } from 'util/getYoutubeLink';
import { gtmEvent } from 'util/gtmEvent';

import styles from './index.module.css';

interface YoutubePlayerProperty {
	className?: string;
	title: string;
	videoListLink: string;
}

const YoutubePlayer: React.FC<YoutubePlayerProperty> = ({ className, title, videoListLink }) => {
	const playListId = getIdFromYoutubeListLink(videoListLink);
	const [{ isYouTubeIframeAPIReady }] = useVideos();
	const player = useRef<YT.Player | null>(null);
	const domId = `youtube-${playListId}`;

	const onPlayerStateChange = (event: YT.OnStateChangeEvent) => {
		if (event.data === YT.PlayerState.PLAYING) {
			const currentTime = player.current?.getCurrentTime() || 0;
			const duration = player.current?.getDuration() || 0;

			const videoEvent = {
				event: 'video_start',
				eventModel: {
					video_title: title,
					video_url: videoListLink,
					video_provider: 'youtube',
					video_current_time: currentTime,
					video_duration: duration,
					video_percent: (currentTime / duration) * 100,
				},
			};

			gtmEvent(videoEvent);
		}
	};

	useEffect(() => {
		if (isYouTubeIframeAPIReady) {
			player.current = new YT.Player(domId, {
				playerVars: {
					listType: 'playlist',
					list: playListId,
				},
				events: {
					onStateChange: onPlayerStateChange,
				},
			});
		}

		return () => {
			if (player.current) {
				player.current.destroy();
			}
		};
	}, [isYouTubeIframeAPIReady, playListId, domId]);

	return <div className={classnames(styles.youtubePlayer, className)} id={domId} />;
};

export default YoutubePlayer;
